import { netsuiteIntegrationSelectors } from '@vy/app-selectors';
import { FC } from 'react';
import { Controller } from 'react-hook-form';
import { ConfigurationSection } from '../../../../../containers/ConfigurationSection';
import { getFlagFromStatus, getStatusByFlag } from '../../../../../types/boolean-flag';
import {
  NetSuiteConfigurationFormValues,
  NetSuiteConfigurationControl,
} from '../../../NetSuiteConfigurationFormSchema';
import { AUTOMATICALLY_SYNC_CREDIT_MEMOS_OPTIONS } from './credit-memo-configuration-const';
import { RadioGroup } from '../../../../../components/RadioGroup';

type CreditMemosConfigurationSectionProps = {
  defaultValues: NetSuiteConfigurationFormValues;
  control: NetSuiteConfigurationControl;
};

export const CreditMemosConfigurationSection: FC<CreditMemosConfigurationSectionProps> = ({
  control,
  defaultValues,
}) => {
  return (
    <ConfigurationSection title="Credit Memos" iconName="CreditCard">
      <Controller
        name="autoExportCreditMemos"
        control={control}
        defaultValue={defaultValues.autoExportCreditMemos}
        render={({ field: { value, onChange } }) => (
          <div data-vy={netsuiteIntegrationSelectors.configuration.autoExportCreditMemosToggle}>
            <RadioGroup
              title="Choose how to sync credit memos"
              value={getFlagFromStatus(value)}
              onChange={(selected) => onChange(getStatusByFlag(selected))}
              keyExtractor={(option) => option.value}
              options={AUTOMATICALLY_SYNC_CREDIT_MEMOS_OPTIONS}
            />
          </div>
        )}
      />
    </ConfigurationSection>
  );
};
